export default "__VITE_ASSET__DUi2fUDA__"